import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';

import { muteSession } from 'flow/actions/chat-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Button from 'flow/components/ui-components/Button';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { ChatSessionKey } from 'flow/types/EntityKeys';

interface Props {
    id?: ChatSessionKey;
}

interface Option {
    label: string;
    duration: Record<'hours', number> | null;
}

const labels = {
    hours: 'datetime.hours',
};

const MuteConversationModal = ({ id }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { closeModal } = useModal();

    const getLabel = (amount: number, unit: keyof typeof labels): Option => ({
        label: i18next.t(labels[unit], { count: amount }) as string,
        duration: { [unit]: amount },
    });

    const quickOptions: Option[] = [
        getLabel(1, 'hours'),
        getLabel(8, 'hours'),
        getLabel(24, 'hours'),
        {
            label: i18next.t('profilechooser.until_further_notice'),
            duration: null,
        },
    ];

    const handleClick = ({ duration }: Option) => {
        dispatch(
            muteSession(
                id,
                duration
                    ? new Date().getTime() + duration.hours * 60 * 60 * 1000
                    : null,
            ),
        );

        closeModal();
    };

    return (
        <BaseModal open={true} header={i18next.t('chatsetting.mute')}>
            <div className="grid grid-cols-2 gap-3">
                {quickOptions.map((option) => (
                    <Button
                        color="gray"
                        key={option.label}
                        className="hover:bg-main hover:darken-0 w-full hover:text-white"
                        onClick={() => handleClick(option)}
                    >
                        {option.label}
                    </Button>
                ))}
            </div>
        </BaseModal>
    );
};

export default MuteConversationModal;
